module.exports = __webpack_public_path__ + "static/media/top-view-nutritional-counter-app-composition.b6b1605f.jpg";